import "reflect-metadata";
import {Container, interfaces} from "inversify";
import SERVICE_IDENTIFIER from "./identifiers";
import {Application} from "../application/application";
import {Service} from "../interface/service";
import {ComponentService} from "../service/component";
import {Component} from "../interface/component";
import {TAG} from "./tags";
import {EventsDetailComponent} from "../components/events-detail";
import {EventEmitter} from "../service/event-emitter";
import {EventsListingComponent} from "../components/events-listing";
import {ModalService} from "../service/modal";
import {ButtonLockedComponent} from "../components/button-locked";
import {EventsModerationComponent} from "../components/events-moderation";
import {CourseFormComponent} from "../components/course-form";
import {CoursePublishComponent} from "../components/course-publish";
import {LoadingService} from "../service/loading";
import {CoursesModerationComponent} from "../components/courses-moderation";
import {FacebookFeedsComponents} from "../components/facebook-feeds";
import {MessageModalComponent} from "../components/message-modal";

let container = new Container();

container.bind<Application>(SERVICE_IDENTIFIER.APPLICATION).to(Application);
container.bind<EventEmitter>(SERVICE_IDENTIFIER.EVENTS).toConstantValue(new EventEmitter());

container.bind<EventsListingComponent>(SERVICE_IDENTIFIER.COMPONENT).to(EventsListingComponent).whenTargetNamed(TAG.EVENTS_LIST);
container.bind<EventsDetailComponent>(SERVICE_IDENTIFIER.COMPONENT).to(EventsDetailComponent).whenTargetNamed(TAG.EVENTS_DETAIL);
container.bind<ButtonLockedComponent>(SERVICE_IDENTIFIER.COMPONENT).to(ButtonLockedComponent).whenTargetNamed(TAG.BUTTON_LOCKED);
container.bind<CoursesModerationComponent>(SERVICE_IDENTIFIER.COMPONENT).to(CoursesModerationComponent).whenTargetNamed(TAG.COURSE_MODERATOR);
container.bind<EventsModerationComponent>(SERVICE_IDENTIFIER.COMPONENT).to(EventsModerationComponent).whenTargetNamed(TAG.EVENT_MODERATOR);
container.bind<CourseFormComponent>(SERVICE_IDENTIFIER.COMPONENT).to(CourseFormComponent).whenTargetNamed(TAG.COURSE_FORM);
container.bind<CoursePublishComponent>(SERVICE_IDENTIFIER.COMPONENT).to(CoursePublishComponent).whenTargetNamed(TAG.COURSE_PUBLISH);
container.bind<Component>(SERVICE_IDENTIFIER.COMPONENT).to(FacebookFeedsComponents).whenTargetNamed(TAG.FACEBOOK_FEEDS);
container.bind<MessageModalComponent>(SERVICE_IDENTIFIER.COMPONENT).to(MessageModalComponent).whenTargetNamed(TAG.MESSAGE_MODAL);

container.bind<Service>(SERVICE_IDENTIFIER.COMPONENTS).toConstantValue(new ComponentService());
container.bind<Service>(SERVICE_IDENTIFIER.MODAL).toConstantValue(new ModalService());
container.bind<Service>(SERVICE_IDENTIFIER.LOADING).toConstantValue(new LoadingService());

container.bind<interfaces.Factory<Component>>("Factory<Component>").toFactory<Component>((context) => {
    return (named: string) => (element: HTMLElement) => {
        let component = context.container.getNamed<Component>(SERVICE_IDENTIFIER.COMPONENT, named);
        component.init(element);
        return component;
    };
});
export default container;